import { Box, Button, Container, Typography } from "@mui/material";
import { useNavigate, useRouteError } from "react-router-dom";
import ParkIcon from "@mui/icons-material/Park";
import { useTranslation } from "react-i18next";

export default function NotFoundPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  // hook นี้ใช้ดึง error จาก React Router v6 มาแสดงได้
  const error: any = useRouteError();

  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        minHeight: "100vh",
        bgcolor: "#f1f8e9", // สีพื้นหลังเขียวอ่อนสบายตา
      }}
    >
      <Container maxWidth="sm" sx={{ textAlign: "center" }}>
        <ParkIcon sx={{ fontSize: 100, color: "#2e7d32", mb: 2 }} />

        <Typography
          variant="h5"
          fontWeight="bold"
          color="text.primary"
          gutterBottom
        >
          {t("Page-Not-Found-Title")}
        </Typography>

        <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
          {t("Page-Not-Found-Desc")}
        </Typography>

        <Button
          variant="contained"
          size="large"
          onClick={() => navigate("/", { replace: true })}
          sx={{
            bgcolor: "#2e7d32",
            borderRadius: 3,
            px: 4,
            py: 1.5,
            fontWeight: "bold",
            "&:hover": { bgcolor: "#1b5e20" },
          }}
        >
          {t("Back-To-Home")}
        </Button>
      </Container>
    </Box>
  );
}
